import Color from "color";
import StringUtil from "./StringUtil";

export interface IColor {
	r: number;
	g: number;
	b: number;
	a?: number;
}

export default class ColorUtil {

	public static getColor(color: IColor): Color {
		const c = Color.rgb(color.r, color.g, color.b, color.a);
		return c;
	}

	public static toHex(color: IColor): string {
		return this.getColor(color).hex();
	}

	public static toRgb(hex: string): IColor {
		return  {r: 0, g: 0, b: 0, a: 1};
	}

	public static invertColor(color: IColor, bw: boolean = false) {
		return ColorUtil.invertHexColor(ColorUtil.toHex(color), bw);
	}

	public static invertHexColor(hex: string, bw: boolean = false): string {

		if (hex.indexOf('#') === 0) {
			hex = hex.slice(1);
		}

		// convert 3-digit hex to 6-digits.
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}

		if (hex.length !== 6) {
			throw new Error('Invalid HEX color.');
		}

		const rV = parseInt(hex.slice(0, 2), 16),
			gV = parseInt(hex.slice(2, 4), 16),
			bV = parseInt(hex.slice(4, 6), 16);

		if (bw) {
			// http://stackoverflow.com/a/3943023/112731
			return (rV * 0.299 + gV * 0.587 + bV * 0.114) > 186
				? '#000000'
				: '#FFFFFF';
		}

		// invert color components
		const r = (255 - rV).toString(16),
			g = (255 - gV).toString(16),
			b = (255 - bV).toString(16);

		// pad each with zeros and return
		return "#" + ColorUtil.padZero(r) + ColorUtil.padZero(g) + ColorUtil.padZero(b);
	}

	private static padZero(str: string, len?: number) {
		len = len || 2;
		const zeros = new Array(len).join('0');
		return (zeros + str).slice(-len);
	}
}

export const invertColor = ColorUtil.invertColor;



// WEBPACK FOOTER //
// ./src/core/util/ColorUtil.ts